const staffFilters = document.querySelectorAll('.c-staff-filter');
const staffCards = document.querySelectorAll('.c-card.staff');
if(staffFilters.length > 0 && staffCards.length > 0) {
  let activeFilter = staffFilters[0].dataset.filter;

  const staffGrid = document.querySelector('.c-grid.staff');
  const emptyMessage = document.querySelector('.c-empty-message');
  if (emptyMessage) {
    gsap.set(emptyMessage, { autoAlpha: 0 });
  }

  const fadeDuration = 0.6;
  const fadeEase = 'power2.inOut';

  staffFilters.forEach(filter => {
    filter.addEventListener('click', () => {
      activeFilter = filter.dataset.filter;

      // UPDATE FILTERS ACTIVE STATE
      staffFilters.forEach(filter => {
        if (filter.dataset.filter !== activeFilter) {
          filter.classList.remove('active');
        } else {
          filter.classList.add('active');
        }
      });

      // FADE OUT STAFF GRID AND EMPTY MESSAGE
      gsap.to([staffGrid, emptyMessage], {
        autoAlpha: 0,
        duration: fadeDuration,
        ease: fadeEase,
        onComplete: () => {
          staffCards.forEach(card => {
            gsap.set(card, { display: 'none' });
          });

          // CHECK IF ALL WAS SELECTED
          if (activeFilter === 'all') {
            // SHOW ALL CARDS AND FADE BACK IN GRID
            gsap.set(staffCards, { display: 'flex' });
            gsap.to(staffGrid, { autoAlpha: 1, duration: fadeDuration, ease: fadeEase });
            return;
          }

          // CHECK IF THERE ARE ANY MATCHES
          let visibleCount = 0;
          staffCards.forEach(card => {
            const cardDepartments = card.dataset.departments;
            if (cardDepartments.split(',').map(dep => dep.trim()).includes(activeFilter)) {
              gsap.set(card, { display: 'flex' });
              visibleCount++;
            } else {
              gsap.set(card, { display: 'none' });
            }
          });

          // SHOW/HIDE EMPTY MESSAGE
          if (visibleCount === 0) {
            gsap.set(emptyMessage, { display: 'block' });
            gsap.to(emptyMessage, { autoAlpha: 1, duration: fadeDuration, ease: fadeEase });
          } else {
            gsap.set(emptyMessage, { display: 'none' });
            gsap.to(staffGrid, { autoAlpha: 1, duration: fadeDuration, ease: fadeEase });
          }

          // REFRESH SCROLL TRIGGER
          setTimeout(() => {
            ScrollTrigger.refresh();
          }, 100);
        },
      });
    });
  });
}